import HTTP from '../common/http-common';
const END_POINT = '/job';

const reState = (jobId) => HTTP.get(END_POINT + "/restate/" + jobId);

const existJobNo = (branchCode, jobNo) => HTTP.get(END_POINT + "/existJobNo", {
    params: {
        branchCode: branchCode,
        jobNo: jobNo
    }
});

const deleteJob = (jobId) => HTTP.delete(END_POINT + "/" + jobId);

const deleteJobServiceDetail = (id) => HTTP.delete(END_POINT + "/service-detail/" + id);

const getJob = (jobId) => HTTP.get(END_POINT + "/" + jobId);

const listJob = (searchDate, licenseNo, branchCode, searchType) => HTTP.get(END_POINT, {
     cache: false,
     params: {
         searchDate:  searchDate,
         licenseNo: licenseNo,
         branchCode: branchCode,
         searchType: searchType
     }
});

const listReceiveParts = (partsCode, jobNo, branchCode) => HTTP.get(END_POINT + "/listReceiveParts", {
    cache: false,
    params: {
        partsCode: partsCode,
        jobNo: jobNo,
        branchCode: branchCode
    }
});

const listJobReceiveParts = (jobNo, branchCode) => HTTP.get(END_POINT + "/listJobReceiveParts", {
    cache: false,
    params: {
        jobNo: jobNo,
        branchCode: branchCode
    }
});
const updateJob = (data) => HTTP.post(END_POINT + "/update", {
    jobId: data.jobId,
    jobNo: data.jobNo,
    jobTime: data.jobTime,
    jobDate: data.jobDate,
    appointDate: data.appointDate,
    jobSize: data.jobSize,
    empContact: data.empContact,
    refJobNo: data.refJobNo,
    branchCode: data.branchCode,
    jobStatusCode: data.jobStatusCode,
    jobServiceDetail: data.jobServiceDetail,
    jobConsumable: data.jobConsumable,
    jobImages: data.jobImages,
    finishDate: data.finishDate,
    deliveryDate: data.deliveryDate,
    invoiceDate: data.invoiceDate,
    invoiceNo: data.invoiceNo,
    carNotPresent: data.carNotPresent,
    waitInsurance: data.waitInsurance,
    postpone: data.postpone,
    postponeDate: data.postponeDate,
    remark: data.remark,
    bpeList: data.bpeList
});

const listWithdrawDetail = (jobNo, branchCode, partsCode) => HTTP.get(END_POINT + "/list-withdraw", {
    params: {
        jobNo: jobNo,
        branchCode: branchCode,
        partsNo: partsCode
    }
});

const withdrawPartsByCode = (jobNo, branchCode, partsCode, withdrawBy) => HTTP.get(END_POINT + "/withdraw", {
    params: {
        jobNo: jobNo,
        branchCode: branchCode,
        partsNo: partsCode,
        withdrawBy: withdrawBy
    }
});

const withdrawParts = (jobNo, branchCode, partsCode, withdrawBy, withdrawQty, receivePartsId) => HTTP.get(END_POINT + "/withdrawById", {
    params: {
        jobNo: jobNo,
        branchCode: branchCode,
        partsNo: partsCode,
        withdrawBy: withdrawBy,
        withdrawQty: withdrawQty,
        receivePartsId: receivePartsId
    }
});

const insertJob = (data) => HTTP.post(END_POINT , {
    jobNo: data.jobNo,
    carId: data.carId,
    licenseNo: data.licenseNo,
    licenseNoProvince: data.licenseNoProvince,
    jobTime: data.jobTime,
    jobDate: data.jobDate,
    appointDate: data.appointDate,
    jobSize: data.jobSize,
    empContact: data.empContact,
    refJobNo: data.refJobNo,
    customerCode: data.customerCode,
    mile: data.mile,
    branchCode: data.branchCode,
    carNotPresent: data.carNotPresent,
    waitInsurance: data.waitInsurance,
    modelCode: data.modelCode,
    remark: data.remark,
    bpeList: data.bpeList
});

const printJob = (jobId) => 
    HTTP.get(END_POINT + "/print/" + jobId, {
        responseType: 'blob'
    });

const printConsumableByJob = (jobId,jobNo) => 
    HTTP.get(END_POINT + "/print/consumable/" + jobId, {
        responseType: 'blob'
    }).then((response) => {
        const url = URL.createObjectURL(new Blob([response], {
            type: 'application/octet-stream'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'รายการแสดงค่าวัสดุสิ้นเปลืองตามใบสั่งซ่อม_เลขที่_' + jobNo + '.xlsx');
        document.body.appendChild(link)
        link.click()
    });

const printConsumableColorByJob = (jobConsumableId,consumableCode,jobId) => 
    HTTP.get(END_POINT + "/print/consumable/color", {
        params: {
            jobConsumableId:  jobConsumableId,
            jobId: jobId
        },
        responseType: 'blob'
    }).then((response) => {
        const url = URL.createObjectURL(new Blob([response], {
            type: 'application/octet-stream'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'วัสดุสิ้นเปลืองสี_รหัส_' + consumableCode + '.xlsx');
        document.body.appendChild(link)
        link.click()
    });

const listControllerBoard = (deliverDate, branchCode) => HTTP.get(END_POINT +  "/controllerBoard", {
    cache: false,
    params: {
        date:  deliverDate,
        branchCode: branchCode
    }
});

const getControllerBoardById = (jobId) => HTTP.get(END_POINT + "/controllerBoard/" + jobId);

const listBoard = (branchCode) => HTTP.get("/board/t1/" + branchCode);
const listBoardWait = (branchCode) => HTTP.get("/board/t2/" + branchCode);
const getBoardheader = (branchCode) => HTTP.get("/board/header/" + branchCode);
const printControllerBoard = (branchCode,branchName) => HTTP.get("/board/print/"+branchCode, {
    responseType: 'blob'
}).then((response) => {
    const url = URL.createObjectURL(new Blob([response], {
        type: 'application/octet-stream'
    }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'controller_board_สาขา_' + branchName + '.xlsx');
    document.body.appendChild(link)
    link.click()
});

export {
    existJobNo,
    deleteJob,
    deleteJobServiceDetail,
    getJob,
    listJob,
    insertJob,
    updateJob,
    withdrawParts,
    listJobReceiveParts,
    printJob,
    printConsumableByJob,
    printConsumableColorByJob,
    listControllerBoard,
    getControllerBoardById,
    listBoard,
    listBoardWait,
    getBoardheader,
    printControllerBoard,
    listReceiveParts,
    withdrawPartsByCode,
    listWithdrawDetail,
    reState
}